import React from 'react';
import { generateImageSource } from '../../../utils/generateImageSource';

const tipsText = [
  'To fill out the company description, consider including information on your company background and locations.',
  'Candidates want to know about your company values and culture, so be sure to emphasize these'
  + ' points. Candidates may be more likely to apply if they get a sense of the work environment.'
];

export const CompanyProfileTips = () => {

  const tips = [];

  tipsText.forEach((tip) => {
    tips.push(<Tip key={tip} tipText={tip} />);
  });

  return (
    <div className="ptp-company-profile__tips-section">
      {tips}
    </div>
  );
};

const Tip = ({ tipText }) => {
  return (
    <div className="ptp-company-profile__tip">
      <div className="ptp-company-profile__tip-label">
        <img
          src={generateImageSource('/images/v1/path-to-pro/light-bulb-orange.svg')}
          className="ptp-company-profile__light-bulb"
        />
        Pro Tip:
      </div>
      {tipText}
    </div>
  );
};
